import React, { useState } from "react";
import NavBar from "../NavBar.js";
import { HREmployeeData as IncomingData } from "./HRData/HREmployeeData.js";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// import searchWhiteIcon from "../Icon.png";
export default function HREmployee() {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");
  const [filtr3, setFiltr3] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.designation === 'Digital Marketing'
      } 
      else if (e.target.value === '2') {
        return x.designation === 'Content Writing'
      }
      else if (e.target.value === '3') {
        return x.designation === 'Social Media Manager'
      }
      else if (e.target.value === '4')  {
        return (x.designation !== 'Social Media Manager' && x.designation !== 'Content Writing' && x.designation !== 'Digital Marketing')

      }
    }));
    };

  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.dept === 'Marketing'
      } 
      else if (e.target.value === '2') {
        return x.dept === 'Design'
      }
      else if (e.target.value === '3') {
        return x.dept === 'Sales'
      }
      else if (e.target.value === '4')  {
        return (x.dept !== 'Marketing' && x.dept !== 'Design' && x.dept !== 'Sales')

      }
    }));
    };

  const handleFilter3 = (e) => {
    setFiltr3(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.type === 'Permanent'
      } 
      else if (e.target.value === '2') {
        return x.type === 'Part time'
      }
      else if (e.target.value === '3') {
        return x.type === 'Temporary'
      }
      else if (e.target.value === '4')  {
        return (x.type !== 'Permanent' && x.type !== 'Part time' && x.type !== 'Temporary')

      }
    }));
    };

  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Employees </span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Employees</h2>
        <div style={{ display: "flex", gap: "6px" }}>
          <div
            className="create-team"
            style={{
              width: "13rem",
              backgroundColor: "#4E6DCB",
            }}
          >
            <span style={{ paddingTop: "1px" }}>
              <AddCircleOutlineIcon />
            </span>
            <div>Add an employee</div>
          </div>
          <div id="Right-content-Down-Filters">
            <MoreVertIcon />
          </div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p>Active</p>
            <p>Resigned</p>
            <p>Terminated</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
              <input
                type="text"
                placeholder="Enter ID Code or Name to search.."
                onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.id.match(val.target.value) ||
                        x.fName.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                  setFiltr2("");
                  setFiltr3("");
                }}
              />
              {console.log(count)}
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select
                name=""
                id=""
                className="order-list-input-right-filters"
                value={filtr1}
                onChange={handleFilter1}
              >
                <option value="" selected>
                  by roles
                </option>
                <option value="1">Digital Marketing</option>
                <option value="2">Content Writing</option>
                <option value="3">Social Media Manager</option>
                <option value="4">Other</option>
              </select>
              <select
                name=""
                id=""
                className="order-list-input-right-filters"
                value={filtr2}
                onChange={handleFilter2}
              >
                <option selected>by department</option>
                <option value="1">Marketing</option>
                <option value="2">Design</option>
                <option value="3">Sales</option>
                <option value="4">Other</option>
              </select>
              <select
                name=""
                id=""
                className="order-list-input-right-filters"
                value={filtr3}
                onChange={handleFilter3}
              >
                <option selected>by job type</option>
                <option value="1">Permanent</option>
                <option value="2">Part time</option>
                <option value="3">Temporary</option>
                <option value="4">Other</option>
              </select>
            </div>
          </div>
          <table className="th-light" style={{ textAlign: "center" }}>
            <tr>
              <th>ID Code</th>
              <th>Full Name</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Type</th>
              <th>Joining Date</th>
              <th>Shift Timing</th>
              <th>Contact no</th>
            </tr>

            {count.length > 0
              ? count.map((val) => {
                  return (
                    <tr>
                      <td>{val.id}</td>
                      <td>{val.fName}</td>
                      <td>{val.designation}</td>
                      <td>{val.dept}</td>
                      <td>{val.type}</td>
                      <td>{val.joinDate}</td>
                      <td>{val.shiftTime}</td>
                      <td>{val.contact}</td>
                    </tr>
                  );
                })
              : IncomingData.map((val) => {
                  return (
                    <tr>
                      <td>{val.id}</td>
                      <td>{val.fName}</td>
                      <td>{val.designation}</td>
                      <td>{val.dept}</td>
                      <td>{val.type}</td>
                      <td>{val.joinDate}</td>
                      <td>{val.shiftTime}</td>
                      <td>{val.contact}</td>
                    </tr>
                  );
                })}
          </table>
        </div>
      </div>
    </>
  );
}
